module.exports = __webpack_public_path__ + "img/z_13_mathias-p-r-reding.fe32a80d.jpg";